export default __webpack_public_path__ + "static/media/orbit.1d83e331.svg";